import { MetricType } from "../gen/graphql"
import { round } from "./math"

export function uppercaseFirstLetter(value: string): string {
  if (value.length === 0) {
    return value
  }

  return value[0].toLocaleUpperCase() + value.slice(1).toLocaleLowerCase()
}

export function formatMetricValue(locale: string, metricType: MetricType, value: number): string {
  return formatNumber(locale, round(value, metricType === MetricType.Ratio ? 2 : 0))
}

export function formatNumber(locale: string, value: number): string {
  return new Intl.NumberFormat(locale).format(value)
}

export function shortenNumber(locale: string, value: number, maxLenght: number): string {
  return new Intl.NumberFormat(locale, {
    notation: "compact",
    compactDisplay: "short",
    maximumSignificantDigits: maxLenght,
  }).format(value)
}
